import { connect } from 'react-redux';
import { PLACEMENTS } from 'constants/tags';
import JobTitlesPage from '../../components/pages/jobTitlesPage';
import PageContainer from '../../components/shared/pageContainer';
import { jobTitlesSelector } from '../../store/selectors/jobTitlesSelector';
import { tagsSelector } from '../../store/selectors/tagsSelector';
import {
  getJobTitles,
  clearJobTitles,
  setJobTitles,
} from '../../store/modules/jobTitles';
import {
  getTagsCategories,
  clearTagsCategories,
  addMultipleTags,
  getPageQuickFilters,
  clearPageQuickFilters,
} from '../../store/modules/tags';
import { useTranslations } from '../../utility/useTranslations';
import { APP_PAGES } from '../../constants/pages';
import { getAllUsers } from '../../store/modules/people';
import { peopleSelector } from '../../store/selectors/peopleSelector';
import { successionSettingsSelector } from '../../store/selectors/successionSettingsSelector';
import {
  getSuccessionJobFamilies,
  getSuccessionCriticality,
  clearSuccessionSettings,
} from '../../store/modules/successionSettings';

const mapStateToProps = state => ({
  ...jobTitlesSelector(state),
  ...tagsSelector(state),
  allUsers: [...peopleSelector(state).allUsers],
  successionSettings: successionSettingsSelector(state),
});

const mapDispatchToProps = dispatch => ({
  getJobTitles: params => getJobTitles(dispatch, params),
  getAllUsers: params => getAllUsers(dispatch, params),
  clearJobTitles: () => dispatch(clearJobTitles()),
  addMultipleTags: data => dispatch(addMultipleTags(data)),
  getTagsCategories: () => getTagsCategories(dispatch),
  getPageQuickFilters: () => getPageQuickFilters(dispatch, PLACEMENTS.JOBS.id),
  clearTagsCategories: () => dispatch(clearTagsCategories()),
  clearPageQuickFilters: () => dispatch(clearPageQuickFilters()),
  setJobTitles: data => dispatch(setJobTitles(data)),
  getSuccessionJobFamilies: () => getSuccessionJobFamilies(dispatch),
  getSuccessionCriticality: () => getSuccessionCriticality(dispatch),
  clearSuccessionSettings: () => dispatch(clearSuccessionSettings()),
});

const JobTitlesPageView = props => {
  const translations = useTranslations(APP_PAGES.JOB_TITLES);

  return (
    <PageContainer {...props} translations={translations}>
      <JobTitlesPage />
    </PageContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(JobTitlesPageView);
